<template>
  <div class="f-qwautohi">
    <div class="form-body" v-if="hi_content">
      <van-tabs
        v-model="hi_content.tab"
        style="border:1px solid #ebedf0; background-color:#fafafa"
      >
        <van-tab title="文字" name="a" class="pd15">
          <div class="form-row">
            <div class="form-row-title">
              文本内容
              <span class="small"></span>
            </div>
            <van-field
              v-model="hi_content.text.content"
              rows="3"
              type="textarea"
              maxlength="500"
              placeholder="请输入打招呼的内容"
              show-word-limit
              border
            />
          </div>
        </van-tab>
        <van-tab title="文字+图片" name="b" class="pd15">
          <div class="form-row">
            <div class="form-row-title">
              文本内容
              <span class="small">若不输入，则只回复图片</span>
            </div>
            <van-field
              v-model="hi_content.text.content"
              rows="3"
              type="textarea"
              maxlength="500"
              placeholder="请输入打招呼的内容"
              show-word-limit
              border
            />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              图片内容
              <span class="small"></span>
            </div>
            <van-uploader
              name="imager_vantuploader"
              @click-preview="clickpreview"
              :before-read="beforeRead"
              :after-read="afterRead"
              v-model="image_vant"
              :preview-full-image="false"
              :max-count="1"
            />
          </div>
        </van-tab>
        <van-tab title="文字+图文链接" name="c" class="pd15">
          <div class="form-row">
            <div class="form-row-title">
              文本内容
              <span class="small">若不输入，则只回复图文链接</span>
            </div>
            <van-field
              v-model="hi_content.text.content"
              rows="3"
              type="textarea"
              maxlength="500"
              placeholder="请输入打招呼的内容"
              show-word-limit
              border
            />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              赠礼链接标题
              <span class="small"></span>
            </div>
            <van-field
              v-model="hi_content.link.title"
              placeholder="请输入链接标题"
              border
            />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              赠礼链接描述
              <span class="small"></span>
            </div>
            <van-field
              v-model="hi_content.link.desc"
              placeholder="请输入图文链接描述"
              border
            />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              赠礼链接小图标
              <span class="small"></span>
            </div>
            <van-uploader
              name="link_vantuploader"
              :before-read="beforeRead"
              :preview-full-image="false"
              :after-read="afterRead"
              :max-count="1"
              @click-preview="clickpreview"
              v-model="link_vant"
            />
          </div>
          <div class="form-row">
            <div class="form-row-title">
              赠礼链接地址
              <span class="small"></span>
            </div>
            <van-field
              v-model="hi_content.link.url"
              placeholder="请输入图文链接地址"
              border
            />
          </div>
        </van-tab>
      </van-tabs>
    </div>
  </div>
</template>

<script>
import { Tabs, Tab } from "vant";
import config from "@/config";
import { newname } from "@/util/crypto";
Vue.use(Tabs);
Vue.use(Tab);

var event = "autohi" + new Date().valueOf();
import Vue from "vue";
export default {
  model: {
    prop: "parent_hi_content", // prop说:我要将value1作为该组件被使用(被父组件调用)时,v-model能取到的值
    event: event, // event说:我emit(触发)change的时候，参数的值就是父组件v-model收到的值。
  },
  props: ["parent_hi_content"],
  watch: {
    hi_content: {
      handler(val, oldval) {
        // console.log("hi_content", val);
        this.$emit(event, val);
      },
      deep: true,
    },
    image_vant: {
      handler(val, oldval) {
        var t = this;
        console.log("image_vant", val);
        if (val && val.length > 0 && val[0].path) {
          t.hi_content.image.media_path = val[0].path;
        }
      },
      deep: true,
    },
    link_vant: {
      handler(val, oldval) {
        var t = this;
        console.log("link_vant", val);
        if (val && val.length > 0 && val[0].path) {
          t.hi_content.link.picurl = val[0].path;
        }
      },
      deep: true,
    },
  },
  name: "f-qwautohi",
  data() {
    return {
      image_vant: [],
      //图文链接图片
      link_vant: [],
      //打招呼方式b
      //   hi_content_tab: "a",
      hi_content: null,
    };
  },
  methods: {
    clickpreview(e) {
      ImagePreview({
        images: [e.url],
        closeable: true,
        closeOnPopstate: true,
      });
      console.log("clickpreview", e);
    },
    //图片格式校验
    beforeRead(file) {
      console.log("beforeRead", file);
      if (file.size > 4 * 1024 * 1024) {
        Toast("图片大小不能超过4M");
        return false;
      }
      if (file.type.indexOf("image") < 0) {
        Toast("只能上传图片格式");
        return false;
      }
      return true;
    },
    //上传图片
    afterRead(file_obj, detail) {
      var t = this;
      var file = file_obj.file;
      //设置加载状态
      file_obj.status = "uploading";
      //更换一个随机名称
      var suffix = ".jpg";
      if (file.name.lastIndexOf(".") >= 0)
        suffix = file.name.substr(file.name.lastIndexOf("."));
      var filename = `${newname()}${suffix}`;
      //开始上传
      t.cos_upload(
        //文件保存的路径和名称
        `/${filename}`,
        //文件内容
        file,
        //上传成功后回调函数
        function(err, res) {
          console.log("upload res:", res);
          console.log("upload err:", err);
          if (err) {
            file_obj.status = "failed";
            file_obj.message = "上传失败";
          } else {
            file_obj.status = "";
            file_obj.url = res.Location;
            file_obj.path = res.path;
            // if(detail.name=="imager_vantuploader") t.dis.hi_content.image.media_path = res.Location;
            // else t.dis.hi_content.link.picurl = res.Location;
          }
        },
        //上传进度更新函数
        function(res) {
          console.log("当前进度：", res);
        }
      );
    },
  },
  components: {},
  computed: {},
  created() {
    var t = this;
    if (t.parent_hi_content) {
      console.log("t.parent_hi_content", t.parent_hi_content);
      t.hi_content = t.parent_hi_content;

      if (t.hi_content.image.media_path) {
        t.image_vant = [
          {
            status: "",
            url:`${config.img_host}${ t.hi_content.image.media_path}`,
            path: t.hi_content.image.media_path,
          },
        ];
        // t.hi_content_tab = "b";
      }
      if (t.hi_content.link.picurl) {
        // t.hi_content_tab = "c";
        t.link_vant = [
          {
            status: "",
            url:`${config.img_host}${ t.hi_content.link.picurl}`,
            path: t.hi_content.link.picurl,
          },
        ];
      }
    } else
      t.hi_content = {
        tab: "a",
        text: {
          content:
            "活动已经结束了哦，关注我的下一次活动吧~",
        },
        image: {
          media_path: "",
        },
        link: {
          title: "",
          picurl: "",
          desc: "",
          url: "",
        },
      };
  },
  mounted() {},
};
</script>

<style lang="scss">
@import "../../../static/scss/var";
</style>
<!-- Add "scoped" attribute to limit CSS to this component only <style scoped  lang="scss" src="../../static/scss/shareindex.scss"></style>-->
